import API from "./";

export const userDetailService = () => API.get("/auth/me/");
export const userDashboardService = () => API.get("/dashboard/");
